import { countries } from 'countries-list';

const API_KEY = '122d8324f70815bd9c7f2577c3d6206c';

interface GeocodingResponse {
  zip: string;
  name: string;
  lat: number;
  lon: number;
  country: string;
}

// Convert country name to ISO 3166 code
export function getCountryCode(countryName: string): string {
  // Default to US if no country provided
  if (!countryName) return 'US';

  const normalizedCountryName = countryName.toLowerCase().trim();
  
  // Direct match for common countries
  const commonCountries: Record<string, string> = {
    'united states': 'US',
    'usa': 'US',
    'us': 'US',
    'united kingdom': 'GB',
    'uk': 'GB',
    'canada': 'CA',
    'australia': 'AU',
  };

  if (commonCountries[normalizedCountryName]) {
    return commonCountries[normalizedCountryName];
  }

  // Search through countries-list
  const countryEntry = Object.entries(countries).find(([_, country]) => 
    country.name.toLowerCase() === normalizedCountryName
  );

  return countryEntry ? countryEntry[0] : 'US';
}

export async function getCoordinates(postalCode: string, country?: string): Promise<{ lat: number; lon: number } | null> {
  try {
    const countryCode = getCountryCode(country || '');
    console.log('Getting coordinates for:', { postalCode, countryCode });
    
    const response = await fetch(
      `https://api.openweathermap.org/geo/1.0/zip?zip=${postalCode},${countryCode}&appid=${API_KEY}`
    );

    if (!response.ok) {
      console.error('Geocoding API error:', response.statusText);
      return null;
    }

    const data: GeocodingResponse = await response.json();
    console.log('Geocoding response:', data);
    
    return {
      lat: data.lat,
      lon: data.lon
    };
  } catch (error) {
    console.error('Error getting coordinates:', error);
    return null;
  }
}